import { apiCall } from '@/assets/module/useApiCall'

const state = {
  allQuuestionContent: '',
  decrypted: '',
  categoryName: '',
  answerContent: ''
};

const getters = {
  getAllQuestionContent: state => {
    return state.allQuuestionContent
  },
  getDecrypted: state => {
    return state.decrypted
  },
  getCategoryNameClicked: state => {
    return state.categoryName
  },
  getAnswerContent: state => {
    return state.answerContent
  },
};

const mutations = {
  setAllContent: function(state, result) {
    state.allQuuestionContent = result
  },
  setDecrypted: function(state, result) {
    state.decrypted = result
  },
  setCategoryName: function(state, result) {
    state.categoryName = result[0]
  },
  setAnswerContent: function(state, result) {
    state.answerContent = result[0]
  },
};

//dev環境
const FUNCTION_NAME = 'fr-ask';

const actions = {
  async getContent({rootState,commit}, params) {
    return apiCall(rootState.apiEndPoint.endPointFaq + FUNCTION_NAME, params)
    .then(response => {
        let result = response
        commit('setAllContent' ,result)
    })
  },
  async getDecryptedId({rootState,commit}, params) {
    return apiCall(rootState.apiEndPoint.endPointFaq + FUNCTION_NAME, params)
    .then(response => {
        let result = response
        commit('setDecrypted' ,result)
    })
  },
  async getCategoryName({rootState,commit}, params) {
    return apiCall(rootState.apiEndPoint.endPointFaq + FUNCTION_NAME, params)
    .then(response => {
        let result = response
        commit('setCategoryName' ,result)
    })
  },
  async getAnswerContent({rootState,commit}, params) {
    return apiCall(rootState.apiEndPoint.endPointFaq + FUNCTION_NAME, params)
    .then(response => {
        let result = response
        commit('setAnswerContent' ,result)
    })
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};